import { render, staticRenderFns } from "./AddCredits.vue?vue&type=template&id=63186698&"
import script from "./AddCredits.vue?vue&type=script&lang=js&"
export * from "./AddCredits.vue?vue&type=script&lang=js&"
import style0 from "./AddCredits.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports